module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/077-jordan-f699af674b5367e60bbb650295f43f8b.svg";